import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { LabeledValue } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import { QuoteTemplateOriginInfo_QuoteFragment } from "./QuoteTemplateOriginInfo.generated.js";
import { useQuoteTemplateOriginInfo_TemplateQuery } from "./QuoteTemplateOriginInfo.generated.js";

interface Props {
  templateOrigin: QuoteTemplateOriginInfo_QuoteFragment["templateOrigin"];
}

// Title only when the viewer can read the template; otherwise (or while it
// loads) the version number stands alone.
export const QuoteTemplateOriginInfo = ({ templateOrigin }: Props) => {
  const { t } = useTranslate("Quote");
  const client = useApolloClient();
  const query = useQuoteTemplateOriginInfo_TemplateQuery({
    client,
    variables: { id: templateOrigin?.templateId ?? "" },
    skip: !templateOrigin,
    // A viewer without access to the template is an expected outcome.
    context: { noErrorNotification: true },
    onError: () => undefined,
  });
  const title = getDataOrNull(query.data?.quoteTemplateLatestAvailableVersion)
    ?.quoteTemplate?.title;

  if (!templateOrigin) return null;

  const { versionNumber } = templateOrigin;

  return (
    <LabeledValue label={t("Created from template", { ns: "Quote" })}>
      {title
        ? t("{title}, version {versionNumber}", {
            ns: "Quote",
            title,
            versionNumber,
          })
        : t("Version {versionNumber}", { ns: "Quote", versionNumber })}
    </LabeledValue>
  );
};
